import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

export class PruningTranslationLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = '/assets/lang/',
    private suffix: string = '.json?v=2026.11.04.39',
  ) {}

  public getTranslation(lang: string): any {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(map((result: object) => this.process(result)));
  }

  private process(object: any): any {
    // Arrays are objects too, so without this guard they'd be rebuilt as index-keyed objects
    // ({ "0": ..., "1": ... }) and downstream Array.isArray checks (e.g. agent.thinking-verbs,
    // time.months) would fail. Keep them as arrays; there's nothing to prune inside them here.
    if (Array.isArray(object)) {
      return object;
    }
    return Object.keys(object)
      .filter((key) =>
        object.hasOwnProperty(key) && typeof object[key] === 'string' ? object[key].toLowerCase() !== 'todo' : true,
      )
      .reduce(
        (result, key) => (
          (result[key] =
            object[key] !== null && typeof object[key] === 'object' ? this.process(object[key]) : object[key]),
          result
        ),
        {},
      );
  }
}
